var _defs, _path, _path2, _path3, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1390.98 1003.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #dee333;\n      }\n\n      .cls-2 {\n        fill: #231f20;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m26.98,868.85V317.96h285.07c51.36,0,92.46,11.82,123.28,35.44,34.92,26.72,52.39,62.93,52.39,108.64,0,50.35-22.86,85.53-68.57,105.56v2.31c29.78,9.77,53.03,26.46,69.72,50.08,16.69,23.63,25.04,51.11,25.04,82.44,0,58.05-21.07,101.96-63.18,131.75-33.39,23.12-77.82,34.67-133.29,34.67H26.98Zm157.95-336.7h100.16c15.92,0,28.51-3.72,37.76-11.17,9.24-7.44,13.87-18.36,13.87-32.75s-4.89-24.91-14.64-33.13c-9.76-8.21-22.34-12.33-37.75-12.33h-99.39v89.38Zm0,210.34h114.8c17.46,0,31.59-4.88,42.38-14.64,10.78-9.76,16.18-22.85,16.18-39.3s-5.53-30.04-16.57-39.29c-11.05-9.24-25.31-13.87-42.76-13.87h-114.03v107.09Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m887.52,569.4v-137.14h474.62v137.14h-157.95v413.75h-161.03v-413.75h-155.64Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m447.67,156.84V19.69h474.62v137.14h-157.95v413.75h-161.03V156.84h-155.64Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1169.64,
    cy: 200.47,
    r: 117.48
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 770.04,
    cy: 825.19,
    r: 117.48
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a2c1fd3173f56a27a99314fa3be9542b.svg";
export { ForwardRef as ReactComponent };